var e=function(e){return e.CustomerDismissed="CUSTOMER_DISMISSED",e.CustomerRequestApproved="CUSTOMER_REQUEST_APPROVED",e.CustomerRequestDeclined="CUSTOMER_REQUEST_DECLINED",e.CustomerRequestFailed="CUSTOMER_REQUEST_FAILED",e}({});export{e as CashAppPayEvents};
//# sourceMappingURL=types.js.map
